import { render, staticRenderFns } from "./employee-leave-portal.html?vue&type=template&id=6f85e3e2&scoped=true&external"
import script from "./employee-leave-portal.js?vue&type=script&lang=js&external"
export * from "./employee-leave-portal.js?vue&type=script&lang=js&external"
import style0 from "./employee-leave-portal.scss?vue&type=style&index=0&id=6f85e3e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85e3e2",
  null
  
)

export default component.exports